import { denormalize } from "normalizr";

import { factoringCompany } from "../../../api/schema";

export default state => {
  try {
    const items = state.groups.factoringCompanies.ids;

    const denormalized = denormalize(
      { items },
      { items: [factoringCompany] },
      state.entities
    );
    return denormalized.items || [];
  } catch (err) {
    return [];
  }
};
